type ThemeModeType = 'dark' | 'light' | 'os';

// Type for the state of the snackbar reducer, which is an array of snackbar configurations
interface ThemeReducerState {
    isDark: boolean;
    mode: ThemeModeType;
}

// Type for the actions that can be dispatched to the snackbar reducer
type ThemeReducerAction =
    | { type: 'reset' }
    | { type: 'set_dark' }
    | { type: 'set_light' }
    | { type: 'set_os' };

const defaultThemeState: ThemeReducerState = {
    isDark: false,
    mode: 'light',
};

const themeReducer = (
    state: ThemeReducerState,
    action: ThemeReducerAction
): ThemeReducerState => {
    const isOperatingSystemInDarkMode = window.matchMedia(
        '(prefers-color-scheme: dark)'
    ).matches;
    switch (action.type) {
        case 'reset':
            return defaultThemeState;
        case 'set_light':
            return {
                ...state,
                isDark: false,
                mode: 'light',
            };
        case 'set_dark':
            return {
                ...state,
                isDark: true,
                mode: 'dark',
            };
        case 'set_os':
            return {
                ...state,
                isDark: isOperatingSystemInDarkMode,
                mode: 'os',
            };
        default:
            return state;
    }
};
export { defaultThemeState, themeReducer };
export type { ThemeModeType, ThemeReducerAction, ThemeReducerState };
